import {
  LIST_FILTER_DATA_UPDATE,
  LIST_FILTER_DATA_SET,
  LIST_FILTER_STATUS_SET,
  LIST_FILTER_SOURCE_CLEAR,
  LIST_FILTER_INITIAL_STATE_SET,
  LIST_FILTER_INITIAL_STATE_UPDATE,
  LIST_FILTER_INITIAL_STATE_CLEAR,
  LIST_FILTER_PRISTINE_SET,
  LIST_FILTER_SET_APPLIED_STATUS,
  LIST_FILTER_CLEAR
} from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LIST_FILTER_DATA_UPDATE:
      const { name, id, value } = action.payload;
      return {
        ...state,
        [id]: {
          ...state[id],
          [name]: { value }
        }
      };
    case LIST_FILTER_DATA_SET: {
      return {
        ...state,
        ...action.payload
      };
    }
    case LIST_FILTER_STATUS_SET: {
      return {
        ...state,
        status: action.payload
      };
    }
    case LIST_FILTER_INITIAL_STATE_SET: {
      return {
        ...state,
        initial: action.payload
      };
    }
    case LIST_FILTER_INITIAL_STATE_UPDATE: {
      const { newState, name: n } = action.payload;
      return {
        ...state,
        initial: {
          ...state.initial,
          [n]: newState
        }
      };
    }
    case LIST_FILTER_INITIAL_STATE_CLEAR: {
      const { initial, ...rest } = state;
      return rest;
    }
    case LIST_FILTER_PRISTINE_SET: {
      return {
        ...state,
        pristine: action.payload
      };
    }
    case LIST_FILTER_SET_APPLIED_STATUS: {
      return {
        ...state,
        applied: action.payload
      };
    }
    case LIST_FILTER_SOURCE_CLEAR:
      const { id: source } = action.payload;
      return {
        ...state,
        [source]: {}
      };
    case LIST_FILTER_CLEAR: {
      return defaultState;
    }
    default:
      return state;
  }
};
